import type { Category } from '@/data/groups';
import { dayFromToday } from '@/data/seed';
import { parseISO } from 'date-fns';

/** 그리드에 보여 줄 날짜 열 — 오늘부터 2주 */
export const GRID_DAYS = Array.from({ length: 14 }, (_, i) => dayFromToday(i));

export const cellKey = (categoryId: string, date: string) => `${categoryId}|${date}`;

/** 주말(금·토) 열은 기본값을 15% 올려 보여 준다 — 셀마다 값이 달라 보이게 하는 더미 규칙. */
const WEEKEND_UPLIFT = 0.15;

export function isWeekendColumn(date: string) {
  const day = parseISO(date).getDay();
  return day === 5 || day === 6;
}

/** 직접 입력한 값이 없을 때의 셀 값 */
export function defaultValue(category: Category, date: string) {
  return isWeekendColumn(date)
    ? Math.round((category.baseValue * (1 + WEEKEND_UPLIFT)) / 100) * 100
    : category.baseValue;
}
